import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-f1f4cd5e"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "main"
};

const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"info-main\" data-v-f1f4cd5e><p class=\"info-title\" data-v-f1f4cd5e>使用目的</p><div class=\"info-desc\" data-v-f1f4cd5e>真人认证、实名认证</div></div><div class=\"info-main\" data-v-f1f4cd5e><p class=\"info-title\" data-v-f1f4cd5e>使用场景</p><div class=\"info-desc\" data-v-f1f4cd5e>用户完成真人认证、实名认证</div></div><div class=\"info-main\" data-v-f1f4cd5e><p class=\"info-title\" data-v-f1f4cd5e>收集主体</p><div class=\"info-desc\" data-v-f1f4cd5e>本APP</div></div>", 3);

const _hoisted_5 = {
  class: "info-main"
};

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "info-title"
}, "收集情况", -1));

const _hoisted_7 = {
  class: "info-desc"
};
const _hoisted_8 = {
  class: "info-main"
};

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "info-title"
}, "信息内容", -1));

const _hoisted_10 = {
  class: "info-desc"
};
const _hoisted_11 = {
  key: 0
};
const _hoisted_12 = {
  key: 1
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_top_title = _resolveComponent("top-title");

  const _component_time_select = _resolveComponent("time-select");

  const _component_bottom_tip = _resolveComponent("bottom-tip");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", null, [_createVNode(_component_top_title, {
    onBack: $setup.back,
    title: "面部特征等信息"
  }, null, 8, ["onBack"]), _createVNode(_component_time_select, {
    onChangeVal: $setup.change
  }, null, 8, ["onChangeVal"]), _hoisted_2, _createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("div", _hoisted_7, "已收集" + _toDisplayString($setup.info.count) + "次", 1)]), _createElementVNode("div", _hoisted_8, [_hoisted_9, _createElementVNode("div", _hoisted_10, [$setup.info.count > 0 && $setup.info.content !== '' ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString($setup.info.content), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_12, "暂无"))])])]), _createVNode(_component_bottom_tip)]);
}